import { render, staticRenderFns } from "./Type2_Weekly_6_Monthly.vue?vue&type=template&id=94afa728&"
import script from "./Type2_Weekly_6_Monthly.vue?vue&type=script&lang=js&"
export * from "./Type2_Weekly_6_Monthly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports